import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { inject, observer } from "mobx-react";
import { Utils, Toastr } from "arv-reactcomponents";
import { Checkout } from "npmlinks-constants";
import { getlastUsedPincode } from "../../utils";
import Analytics from "../../analytics";
import Event from "../../analytics/eventFactory";

@withRouter
@inject("CheckoutStore", "AddressStore")
@observer
class CheckoutValidator extends Component {
  static ShowToastr(message = Checkout.CHECKOUT_MESSAGES.ERROR_MESSAGE) {
    Toastr.showToastr({
      className: "nwc-toastr-list-danger nw-toastr",
      message,
      timeout: 3000,
    });
  }
  static triggerGaForDeliveryWithoutPincode() {
    Analytics.trackEvent({
      category: window.pageType,
      action: Event.action.CHECKOUT_DELIVERY_WITHOUT_PINCODE,
    });
  }
  constructor() {
    super();
    this.validateCheckout = this.validateCheckout.bind(this);
    this.modifiedChild = this.modifiedChild.bind(this);
    this.initialize = this.initialize.bind(this);
    this.handleOosCase = this.handleOosCase.bind(this);
    this.handleNonDeliverableCase = this.handleNonDeliverableCase.bind(this);
    this.showSavedAddressPopup = this.showSavedAddressPopup.bind(this);
    this.showAddAddressPopup = this.showAddAddressPopup.bind(this);
    this.handleDeliveryNotSelectedCase = this.handleDeliveryNotSelectedCase.bind(
      this,
    );
    this.deliveryMisMatch = this.deliveryMisMatch.bind(this);
    this.handleDeliveryMisMatch = this.handleDeliveryMisMatch.bind(this);
    this.handleNoProducts = this.handleNoProducts.bind(this);
    this.triggerGaStepOneDone = this.triggerGaStepOneDone.bind(this);
  }
  componentDidMount() {
    if (this.preValidate) {
      this.initialize();
    }
  }
  get preValidate() {
    return this.props.preValidate;
  }
  get redirect() {
    return this.props.redirect;
  }
  get currentPincodeInUse() {
    const { pincode } = this.props.CheckoutStore;
    return pincode || getlastUsedPincode();
  }
  get hasOosProducts() {
    const { cartItems } = this.props.CheckoutStore;
    return cartItems.some(product => product.sellableQty === 0);
  }
  get hasNonServiceableProducts() {
    const { cartItems } = this.props.CheckoutStore;
    return cartItems.some(product => !product.shippingMethod);
  }
  get hasAddressButNotSelected() {
    const { userAddresses } = this.props.AddressStore;
    const { shippingAddress } = this.props.CheckoutStore;
    const [useableAddress] = userAddresses.filter(
      address => address.pincode === this.currentPincodeInUse,
    );
    return !shippingAddress && useableAddress;
  }
  get someProductHaveNonStoreDelivery() {
    const { cartItems } = this.props.CheckoutStore;
    const properDeliveryProducts = cartItems.filter(
      product =>
        product.shippingMethod !== Checkout.CHECKOUT_DELIVERY_OPTIONS.STOREPICK,
    );
    return properDeliveryProducts.length > 0;
  }
  get atleastOneProductDeliveryNotSelected() {
    const { cartItems } = this.props.CheckoutStore;
    return cartItems.some(product => !product.shippingMethod);
  }
  get noAddressForPincode() {
    const { userAddresses } = this.props.AddressStore;
    const { shippingAddress } = this.props.CheckoutStore;
    const [useableAddress] = userAddresses.filter(
      address => address.pincode === this.currentPincodeInUse,
    );
    return !shippingAddress && !useableAddress;
  }
  get noProducts() {
    const { cartItems } = this.props.CheckoutStore;
    return cartItems.length === 0;
  }
  get error() {
    return this.props.CheckoutStore.error;
  }
  triggerGaStepOneDone() {
    if (!this.preValidate) {
      Analytics.trackEvent({
        category: window.pageType,
        action: Event.action.Checkout_Step_1_Done,
      });
    }
  }
  initialize() {
    const { cartItems } = this.props.CheckoutStore;
    if (cartItems.length > 0) {
      this.validateCheckout();
    } else if (Checkout.STAYINPAYMENT) {
      this.props.CheckoutStore.updateCart()
        .then(response => this.validateCheckout(response))
        .catch(this.validateCheckout);
    } else if (
      this.props.location.pathname !==
      Checkout.CHECKOUT_ROUTES.SUPPORTED.paymentfailure
    ) {
      this.props.history.replace(Checkout.CHECKOUT_ROUTES.SUPPORTED.shipping);
    } else {
      this.props.onSuccess();
    }
  }
  deliveryMisMatch(response) {
    const { cartItems } = this.props.CheckoutStore;
    const requestDeliveryMethods =
      (response &&
        response.requestBody &&
        response.requestBody.selectedShippingMethods) ||
      [];
    const responseDeliverMethods = cartItems.map(item => ({
      skuId: item.skuId,
      shippingMethod: item.shippingMethod,
    }));
    let retFlag = false;
    responseDeliverMethods.forEach(item => {
      const matchingRequestItem = requestDeliveryMethods.find(
        sku => sku.skuId === item.skuId,
      );
      retFlag =
        retFlag ||
        (matchingRequestItem &&
          matchingRequestItem.shippingMethod !== item.shippingMethod);
    });
    return retFlag;
  }
  validateCheckout(response) {
    if (this.error) {
      CheckoutValidator.ShowToastr();
    } else if (this.noProducts) {
      this.handleNoProducts();
    } else if (this.deliveryMisMatch(response)) {
      this.handleDeliveryMisMatch();
    } else if (this.hasOosProducts) {
      this.handleOosCase();
    } else if (this.hasNonServiceableProducts) {
      this.handleNonDeliverableCase();
    } else if (
      this.hasAddressButNotSelected &&
      this.someProductHaveNonStoreDelivery
    ) {
      this.showSavedAddressPopup();
    } else if (
      this.noAddressForPincode &&
      this.someProductHaveNonStoreDelivery
    ) {
      this.showAddAddressPopup();
    } else if (this.atleastOneProductDeliveryNotSelected) {
      this.handleDeliveryNotSelectedCase();
    } else if (this.props.proceedToPayment) {
      this.triggerGaStepOneDone();
      this.props.onSuccess();
      this.props.history.push(Checkout.CHECKOUT_ROUTES.SUPPORTED.payment);
    } else {
      this.props.onSuccess();
    }
  }
  handleNoProducts() {
    this.props.onError();
    this.props.CheckoutStore.clearPresets();
    CheckoutValidator.ShowToastr(Checkout.CHECKOUT_MESSAGES.NO_PRODUCTS);
    if (this.redirect) {
      this.props.history.replace(Checkout.CHECKOUT_ROUTES.SUPPORTED.shipping);
    }
  }
  handleDeliveryMisMatch() {
    this.props.onError();
    this.props.CheckoutStore.clearPresets();
    CheckoutValidator.ShowToastr(Checkout.CHECKOUT_MESSAGES.DELIVERY_MISMATCH);
    if (this.redirect) {
      this.props.history.replace(Checkout.CHECKOUT_ROUTES.SUPPORTED.shipping);
    }
  }
  handleOosCase() {
    this.props.onError();
    CheckoutValidator.ShowToastr(Checkout.CHECKOUT_MESSAGES.OOS_TOASTR);
    if (this.redirect) {
      this.props.history.replace(Checkout.CHECKOUT_ROUTES.SUPPORTED.shipping);
    }
  }
  handleNonDeliverableCase() {
    this.props.onError();
    CheckoutValidator.ShowToastr(
      Checkout.CHECKOUT_MESSAGES.NON_DELIVERABLE_TOASTR,
    );
    if (this.redirect) {
      this.props.history.replace(Checkout.CHECKOUT_ROUTES.SUPPORTED.shipping);
    }
  }
  handleDeliveryNotSelectedCase() {
    this.props.onError();
    CheckoutValidator.ShowToastr(
      Checkout.CHECKOUT_MESSAGES.SELECT_DELIVERY_METHOD,
    );
    if (this.redirect) {
      this.props.history.replace(Checkout.CHECKOUT_ROUTES.SUPPORTED.shipping);
    }
  }
  showSavedAddressPopup() {
    this.props.onError();
    if (this.redirect) {
      CheckoutValidator.ShowToastr(
        Checkout.CHECKOUT_MESSAGES.ADDRESS_NOT_SELECTED,
      );
      this.props.history.replace(Checkout.CHECKOUT_ROUTES.SUPPORTED.shipping);
    } else {
      CheckoutValidator.triggerGaForDeliveryWithoutPincode();
      this.props.AddressStore.setSavedAddressModal(
        true,
        Checkout.CHECKOUT_MESSAGES.ADDRESS.SAVED_ADDRESSES_TITLE,
      );
    }
  }
  showAddAddressPopup() {
    this.props.onError();
    if (this.redirect) {
      CheckoutValidator.ShowToastr(
        Checkout.CHECKOUT_MESSAGES.ADDRESS_NOT_SELECTED,
      );
      this.props.history.replace(Checkout.CHECKOUT_ROUTES.SUPPORTED.shipping);
    } else {
      CheckoutValidator.triggerGaForDeliveryWithoutPincode();
      this.props.AddressStore.setAddAddressModal(
        true,
        Checkout.CHECKOUT_MESSAGES.ADDRESS.NEW_DELIVERY_ADDRESS_TITLE,
        Checkout.CHECKOUT_BUTTON_TEXTS.DELIVER_HERE,
        true,
      );
    }
  }

  modifiedChild(child) {
    const onClickFn = child.props.onClick || Utils.noop;
    return React.cloneElement(child, {
      onClick: e => {
        this.validateCheckout(e);
        onClickFn(e);
      },
    });
  }
  render() {
    const { children } = this.props;
    if (children) {
      return (
        <Fragment>{React.Children.map(children, this.modifiedChild)}</Fragment>
      );
    }
    return <div />;
  }
}

CheckoutValidator.defaultProps = {
  proceedToPayment: true,
  preValidate: false,
  redirect: false,
  onError: Utils.noop,
  onSuccess: Utils.noop,
};

CheckoutValidator.wrappedComponent.propTypes = {
  onSuccess: PropTypes.func,
  proceedToPayment: PropTypes.bool,
  onError: PropTypes.func,
  redirect: PropTypes.bool,
  preValidate: PropTypes.bool,
  children: PropTypes.node.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    replace: PropTypes.func.isRequired,
  }).isRequired,
  CheckoutStore: PropTypes.shape({
    error: PropTypes.shape({}).isRequired,
    cartItems: PropTypes.shape({}).isRequired,
    updateCart: PropTypes.func.isRequired,
    shippingAddress: PropTypes.shape({}).isRequired,
    clearPresets: PropTypes.func.isRequired,
    pincode: PropTypes.string.isRequired,
  }).isRequired,
  AddressStore: PropTypes.shape({
    getUserAddresses: PropTypes.func.isRequired,
    currentPincode: PropTypes.string.isRequired,
    userAddresses: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    setSavedAddressModal: PropTypes.func.isRequired,
    setAddAddressModal: PropTypes.func.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("CheckoutStore", "AddressStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: CheckoutValidator.wrappedComponent,
  component: CheckoutValidator,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/CheckoutValidator/index.js